import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { ITextAreaProps } from './ITextAreaProps'
import clsx from 'clsx'
import { useTextAreaValidationSchema } from './TextAreaValidationSchema'

interface ITextAreaFieldProps extends HTMLAttributes<HTMLTextAreaElement>, ITextAreaProps { }

export const SimpleTextArea: FC<ITextAreaFieldProps> = (props) => {
    const { id, value: initValue, placeholder, title, className, readOnly, disabled } = props
    const schema = useTextAreaValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch(error => setError(error.message))
    }

    return <>
        <textarea
            id={id}
            title={title}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            value={value}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
